/* ==========================================================================
   Skogstad Sport – navigasjon
   Motstykket til assets/skogstad-navigasjon.css.

   Lastes med defer, etter theme.js, så theme.a11y og theme-hendelsene
   finnes. Skriptet er et TILLEGG, ikke en forutsetning: uten det er
   toppnivået fortsatt ekte lenker til kategorisidene, mega-panelene ligger
   skjult, og mobilskuffen viser rotnivået. Ingen kritisk vei forsvinner.
   ========================================================================== */
(function () {
  'use strict';

  /* ==================================================================
     Headerens tilstand

     Motstykket til seksjon 0 i assets/skogstad-navigasjon.css. Én funksjon
     avgjør hva headeren er, og skriver svaret som et attributt. Ingen
     annen kode – verken her eller i CSS – har lov til å bestemme dette.

       meny åpen        → solid
       ellers scrollet  → solid
       ellers overlay   → hero
       ellers           → solid

     Rekkefølgen er hele poenget. Menyen har høyest prioritet, så en åpen
     dropdown mot en gjennomsiktig header er en tilstand som ikke finnes.

     Hvorfor MutationObserver og ikke en egen scroll-lytter: Impulse har
     allerede en. theme.js legger .site-header--stuck på headeren når
     kunden har rullet forbi 250 px, og tar den av igjen. Å telle piksler
     en gang til ville gitt oss to terskler som kan komme i utakt – og en
     scroll-lytter til på en side som allerede har flere. Vi ser på
     resultatet av temaets egen beregning i stedet. Null scroll-arbeid.
     ================================================================== */
  var Header = (function () {
    var wrapper = null;
    var siteHeader = null;
    var observer = null;

    var erOverlay = false;
    var erScrollet = false;
    var erMenyAapen = false;

    function les() {
      erOverlay = wrapper.classList.contains('header-wrapper--sticky');
      erScrollet = siteHeader.classList.contains('site-header--stuck');
    }

    function skriv() {
      var solid = erMenyAapen || erScrollet || !erOverlay;
      wrapper.setAttribute('data-header-tilstand', solid ? 'solid' : 'hero');
      wrapper.setAttribute('data-header-meny', erMenyAapen ? 'true' : 'false');
    }

    return {
      init: function () {
        wrapper = document.getElementById('HeaderWrapper');
        siteHeader = document.getElementById('SiteHeader');
        if (!wrapper || !siteHeader) return;

        erMenyAapen = false;
        les();
        skriv();

        if (observer) observer.disconnect();

        /* Vi lytter på klasseendringer på begge, ikke bare headeren:
           theme.js kan fjerne .header-wrapper--sticky helt (temaeditoren,
           kolleksjonsside uten bilde), og da er siden ikke lenger en
           overlay-side. Vi skriver bare data-attributter her, og de er
           ikke med i attributeFilter, så observeren kan ikke utløse seg
           selv. */
        observer = new MutationObserver(function () {
          les();
          skriv();
        });
        observer.observe(siteHeader, { attributes: true, attributeFilter: ['class'] });
        observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      },

      settMeny: function (aapen) {
        if (!wrapper || erMenyAapen === aapen) return;
        erMenyAapen = aapen;
        skriv();
      }
    };
  })();

  /* ------------------------------------------------------------------
     Hover-intent

     Problemet uten forsinkelse: kunden drar musa fra logoen til
     handlekurven og river opp fire mega-menyer på veien. Menyen skal
     åpne seg når noen VIL åpne den, ikke når noen passerer.

     AAPNE_MS ligger like over det som skiller «på vei et annet sted» fra
     «peker på dette». Under ~120 ms åpner den fortsatt tilfeldig; over
     ~250 ms føles den treg.

     LUKKE_MS var 300 før. Den er senket til 260 nå som panelet er
     436 px og ikke 700+: begrunnelsen for en lang forsinkelse var at
     kunden måtte kunne dra musa diagonalt fra «Dame» helt ned til
     «Skalljakker» nederst i et høyt panel uten å miste menyen på veien
     over headerens padding. Med et lavere panel er den strekningen
     kortere, og da blir en lang forsinkelse det motsatte problemet:
     menyen henger igjen etter at kunden har forlatt den.
     ------------------------------------------------------------------ */
  var AAPNE_MS = 160;
  var LUKKE_MS = 260;

  var aapneTimer = null;
  var lukkeTimer = null;
  var aapentPunkt = null;
  var ventendePunkt = null;
  var globaleLyttereSatt = false;

  /* Holder styr på gjeldende drawerOpen-lytter, så temaeditoren ikke
     stabler opp én ny for hver innstillingsendring. */
  var mobilNullstill = null;

  /* Escape lukker menyen og gir fokus tilbake til punktet den tilhørte.
     Men fokus på et toppnivåpunkt er nettopp det som ÅPNER menyen – uten
     dette flagget lukket Escape menyen og åpnet den igjen i samme
     øyeblikk, og for kunden så det ut som om tasten ikke virket. Flagget
     gjelder nøyaktig én fokushendelse. */
  var hoppOverNesteFokus = false;

  /* Peker uten hover = touch. Da finnes det ingen «peke på»-tilstand, og
     første trykk må åpne menyen framfor å navigere. Andre trykk på samme
     punkt navigerer, så veien til kategorisiden aldri er stengt. */
  function harHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function avbrytAapne() {
    if (aapneTimer) { clearTimeout(aapneTimer); aapneTimer = null; }
    ventendePunkt = null;
  }

  function avbrytLukke() {
    if (lukkeTimer) { clearTimeout(lukkeTimer); lukkeTimer = null; }
  }

  function avbrytTimere() {
    avbrytAapne();
    avbrytLukke();
  }

  function settAapen(punkt) {
    punkt.setAttribute('data-nav-open', 'true');
    var utloser = punkt.querySelector('[data-nav-trigger]');
    if (utloser) utloser.setAttribute('aria-expanded', 'true');
  }

  function settLukket(punkt) {
    punkt.setAttribute('data-nav-open', 'false');
    var utloser = punkt.querySelector('[data-nav-trigger]');
    if (utloser) utloser.setAttribute('aria-expanded', 'false');
  }

  function aapne(punkt) {
    if (!punkt || aapentPunkt === punkt) return;
    avbrytTimere();

    if (aapentPunkt) {
      /* Nabobytte. Flaten står allerede der og har riktig farge – bare
         innholdet skal skiftes. Uten data-nav-bytter ville det gamle
         panelet tone ut mens det nye toner inn, og siden begge er
         ugjennomsiktige, ville butikken bak lyst gjennom midt i
         overgangen. Attributtet skrur av overgangen i det ene bildet
         byttet skjer, og fjernes igjen etter at det er tegnet.

         To rAF-er, ikke én: den første kjører før tegningen av endringen,
         den andre etter. Fjerner vi attributtet for tidlig, rekker
         nettleseren å regne ut en overgang likevel. */
      var vert = aapentPunkt.closest('.site-header') || document.getElementById('SiteHeader');
      settLukket(aapentPunkt);
      if (vert) {
        vert.setAttribute('data-nav-bytter', '');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { vert.removeAttribute('data-nav-bytter'); });
        });
      }
    }

    settAapen(punkt);
    aapentPunkt = punkt;
    Header.settMeny(true);
  }

  function lukk(punkt) {
    if (!punkt) return;
    settLukket(punkt);
    if (aapentPunkt === punkt) {
      aapentPunkt = null;
      Header.settMeny(false);
    }
  }

  function lukkAlle() {
    avbrytTimere();
    if (aapentPunkt) {
      lukk(aapentPunkt);
    } else {
      Header.settMeny(false);
    }
  }

  function planleggAapne(punkt) {
    if (aapentPunkt === punkt || ventendePunkt === punkt) return;
    avbrytAapne();
    ventendePunkt = punkt;
    aapneTimer = setTimeout(function () {
      aapneTimer = null;
      ventendePunkt = null;
      aapne(punkt);
    }, AAPNE_MS);
  }

  function planleggLukke() {
    if (!aapentPunkt || lukkeTimer) return;
    avbrytAapne();
    lukkeTimer = setTimeout(function () {
      lukkeTimer = null;
      lukkAlle();
    }, LUKKE_MS);
  }

  /* ------------------------------------------------------------------
     Desktop

     Hendelsene ligger på HEADEREN, ikke på hvert menypunkt. Det er
     forskjellen mellom en meny som føles sammenhengende og en som ikke
     gjør det:

     · Header og dropdown er én hover-region. Panelet er et DOM-barn av
       headeren, så mouseleave fyrer ikke når kunden går fra lenka og ned
       i panelet – uansett hvor panelet ligger geometrisk. Går hun ut i
       siden, fyrer den, og nedtellingen starter.
     · Å gå fra Dame til Herre er ett bytte, ikke en lukking og en åpning.
       mouseover treffer det nye punktet mens det gamle fortsatt er åpent,
       og aapne() håndterer det som et innholdsbytte.
     · Én lytter uansett hvor mange navigasjonsfelt layouten har. Impulses
       «center-split» rendrer to <nav>-er; den gamle koden bandt bare opp
       den første.
     ------------------------------------------------------------------ */
  function initDesktop(rot) {
    var header = rot.querySelector('#SiteHeader') || rot.querySelector('.site-header');
    if (!header) return;

    var punkter = header.querySelectorAll('[data-nav-item][data-nav-har-panel]');
    if (!punkter.length) return;

    header.addEventListener('mouseover', function (evt) {
      if (!harHover()) return;
      if (!evt.target || !evt.target.closest) return;

      var punkt = evt.target.closest('[data-nav-item][data-nav-har-panel]');

      if (punkt) {
        avbrytLukke();
        if (aapentPunkt && aapentPunkt !== punkt) {
          aapne(punkt);          /* nabobytte, uten forsinkelse */
        } else if (!aapentPunkt) {
          planleggAapne(punkt);  /* første åpning, med hover-intent */
        }
        return;
      }

      /* Inne i headeren, men ikke på et menypunkt: logoen, søk, konto,
         handlekurv. Kunden er på vei et annet sted. */
      avbrytAapne();
      planleggLukke();
    });

    /* Fyrer ikke når musa går ned i panelet – det er et barn av headeren. */
    header.addEventListener('mouseleave', function () {
      if (!harHover()) return;
      planleggLukke();
    });

    Array.prototype.forEach.call(punkter, function (punkt) {
      var utloser = punkt.querySelector('[data-nav-trigger]');
      if (!utloser) return;

      /* Tastatur: fokus på toppnivålenka åpner panelet med én gang – ingen
         forsinkelse, for det finnes ingen tilfeldig fokusering. Deretter
         tabber man rett inn i kolonnene, fordi de nå er synlige og dermed
         med i tabulatorrekkefølgen. Enter på lenka går til kategorisiden,
         som den skal – toppnivået er og blir en ekte lenke. */
      utloser.addEventListener('focus', function () {
        if (hoppOverNesteFokus) {
          hoppOverNesteFokus = false;
          return;
        }
        avbrytTimere();
        aapne(punkt);
      });

      /* Første trykk åpner, andre navigerer. Bare på touch. */
      utloser.addEventListener('click', function (evt) {
        if (harHover()) return;
        if (punkt.getAttribute('data-nav-open') === 'true') return;
        evt.preventDefault();
        aapne(punkt);
      });

      punkt.addEventListener('focusout', function (evt) {
        if (evt.relatedTarget && punkt.contains(evt.relatedTarget)) return;
        lukk(punkt);
      });
    });

    /* Én gang, ikke på nytt for hver seksjonslasting i temaeditoren. */
    if (globaleLyttereSatt) return;
    globaleLyttereSatt = true;

    /* Klikk utenfor headeren lukker. Nødvendig på touch, der det ikke
       finnes noen mouseleave. Menyen er ikke modal: klikket går videre til
       det kunden faktisk trykket på. */
    document.addEventListener('click', function (evt) {
      if (!aapentPunkt) return;
      if (aapentPunkt.contains(evt.target)) return;
      lukkAlle();
    });

    /* Escape lukker og gir fokus tilbake til punktet menyen tilhører, slik
       at tabulatorrekkefølgen fortsetter der brukeren var – ikke fra
       toppen av dokumentet. */
    document.addEventListener('keydown', function (evt) {
      if (evt.key !== 'Escape' && evt.key !== 'Esc') return;
      if (!aapentPunkt) return;
      var utloser = aapentPunkt.querySelector('[data-nav-trigger]');
      lukkAlle();
      if (utloser) {
        hoppOverNesteFokus = true;
        utloser.focus();
        /* Sto fokus allerede der, kommer det ingen focus-hendelse å hoppe
           over. Da må flagget ryddes bort selv, ellers spiser det den
           neste ekte fokuseringen. */
        hoppOverNesteFokus = false;
      }
    });
  }

  /* ------------------------------------------------------------------
     Mobil drilldown

     Alle nivåer er rendret som ekte lenker fra start. Skriptet flytter
     bare hvilket panel som er synlig, og holder toppradens venstre plass
     i takt med det: merket på rotnivå, «‹ Tilbake» i et panel.

     Tre ting skriptet eier, som CSS ikke kan:
     · retningen på overgangen (fram eller tilbake)
     · rullestillingen – nytt nivå starter på toppen, tilbake havner der
       kunden var
     · fokus – inn til nivåtittelen på veien fram, tilbake til raden man
       kom fra på veien tilbake

     Fokusfellen, escape-for-å-lukke, body scroll lock og fokusretur til
     menyknappen er Impulses (theme.Drawers). Vi bygger ikke noe av det på
     nytt – drilldown ligger INNE i skuffen deres.
     ------------------------------------------------------------------ */
  function initMobil(rot) {
    var skuff = rot.querySelector('[data-mobilnav]');
    if (!skuff) return;

    var beholder = skuff.querySelector('[data-nav-paneler]');
    var paneler = skuff.querySelectorAll('[data-nav-panel-id]');
    var merke = skuff.querySelector('[data-nav-merke]');
    var tilbake = skuff.querySelector('[data-nav-tilbake]');
    if (!beholder || !paneler.length) return;

    var OVERGANG_MS = 220;

    var rotId = paneler[0].getAttribute('data-nav-panel-id');
    var naavaerende = rotId;

    /* Raden som åpnet hvert panel. Brukes til to ting: å holde
       aria-expanded i synk, og å gi fokus tilbake dit kunden kom fra – ikke
       til toppen av dokumentet. */
    var utlosere = {};
    var rullestilling = {};
    var forlaterTimer = null;

    function finnPanel(id) {
      return skuff.querySelector('[data-nav-panel-id="' + id + '"]');
    }

    function ryddForlater() {
      if (forlaterTimer) {
        clearTimeout(forlaterTimer);
        forlaterTimer = null;
      }
      Array.prototype.forEach.call(paneler, function (p) {
        p.classList.remove('er-forlater');
      });
    }

    function vis(id, retning, settFokus) {
      var panel = finnPanel(id);
      if (!panel) return;

      var forrige = finnPanel(naavaerende);
      ryddForlater();

      beholder.setAttribute('data-nav-retning', retning === 'tilbake' ? 'tilbake' : 'fram');

      if (forrige && forrige !== panel) {
        /* Rullestillingen tas vare på FØR panelet forlates, så den kan
           legges tilbake om kunden kommer tilbake hit. */
        rullestilling[naavaerende] = forrige.scrollTop;
        forrige.classList.remove('er-aktiv');
        forrige.classList.add('er-forlater');
        forlaterTimer = setTimeout(function () {
          forrige.classList.remove('er-forlater');
          forlaterTimer = null;
        }, OVERGANG_MS);
      }

      panel.classList.add('er-aktiv');
      naavaerende = id;

      /* Nytt nivå starter på toppen – ellers arver kunden en rullestilling
         som hører til en helt annen liste. På veien tilbake er det
         motsatt: da skal hun finne igjen stedet hun forlot. */
      panel.scrollTop = retning === 'tilbake' ? (rullestilling[id] || 0) : 0;

      var forelder = panel.getAttribute('data-nav-forelder');

      if (merke) merke.hidden = !!forelder;
      if (tilbake) tilbake.hidden = !forelder;

      /* aria-expanded speiler hvilket panel som står åpent. */
      Object.keys(utlosere).forEach(function (nokkel) {
        utlosere[nokkel].setAttribute('aria-expanded', nokkel === id ? 'true' : 'false');
      });

      if (!settFokus) return;

      /* Fokus til nivåtittelen. Den har tabindex="-1" og er en <h2>, så en
         skjermleser leser «Dame, overskrift nivå 2» – altså hvor du
         havnet – framfor å hoppe rett inn i første lenke uten kontekst. */
      var tittel = panel.querySelector('[data-nav-paneltittel]');
      if (tittel) {
        tittel.focus();
        return;
      }
      var forste = panel.querySelector('a, button, input');
      if (forste) forste.focus();
    }

    /* Utløserne registreres én gang, så aria-expanded kan holdes i synk
       uten å lete i DOM-en for hvert trykk. */
    Array.prototype.forEach.call(skuff.querySelectorAll('[data-nav-aapne]'), function (knapp) {
      utlosere[knapp.getAttribute('data-nav-aapne')] = knapp;
    });

    skuff.addEventListener('click', function (evt) {
      if (!evt.target || !evt.target.closest) return;

      var aapner = evt.target.closest('[data-nav-aapne]');
      if (aapner && skuff.contains(aapner)) {
        evt.preventDefault();
        vis(aapner.getAttribute('data-nav-aapne'), 'fram', true);
        return;
      }

      if (tilbake && evt.target.closest('[data-nav-tilbake]')) {
        evt.preventDefault();
        var panel = finnPanel(naavaerende);
        var forelder = panel && panel.getAttribute('data-nav-forelder');
        var fra = naavaerende;
        vis(forelder || rotId, 'tilbake', false);
        /* Fokus tilbake til raden kunden kom fra, ikke til første rad i
           lista. Da fortsetter tabulatorrekkefølgen der hun var. */
        var utloser = utlosere[fra];
        if (utloser) utloser.focus();
      }
    });

    function nullstill() {
      beholder.classList.add('er-uten-overgang');
      vis(rotId, 'tilbake', false);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          beholder.classList.remove('er-uten-overgang');
        });
      });
    }

    /* Skuffen lukkes og åpnes igjen: start alltid på rotnivå. Å komme
       tilbake til «Dame → …» fra i går er ikke hjelpsomt – kunden har
       nettopp trykket på menyknappen for å begynne på nytt.

       Uten animasjon: skuffen er ikke synlig ennå når dette skjer, og et
       kryssfade ingen ser er bare 200 ms der ingenting kan trykkes. */
    if (mobilNullstill) {
      document.removeEventListener('drawerOpen.NavDrawer', mobilNullstill);
    }
    mobilNullstill = nullstill;
    document.addEventListener('drawerOpen.NavDrawer', nullstill);

    nullstill();
  }

  function init() {
    var seksjon = document.querySelector('[data-section-type="header"]');
    var rot = seksjon || document;

    /* ── Mobilskuffen ligger UTENFOR [data-section-type="header"] ──────

       sections/header.liquid rendrer `drawer-menu` på linje 30, mens
       <div data-section-type="header"> ikke åpner før linje 81. #NavDrawer
       er altså et SØSKEN av det elementet, ikke et barn.

       initMobil fikk `rot` inn og gjorde rot.querySelector('[data-mobilnav]'),
       som dermed alltid returnerte null. Funksjonen returnerte på første
       linje, klikklytteren ble aldri satt opp, og ingenting skjedde når
       kunden trykket på et menypunkt. Rotnivået SÅ riktig ut hele tiden,
       fordi Liquid gir rotpanelet `er-aktiv` fra start – feilen var usynlig
       til man faktisk trykket.

       Vi går ett hakk ut, til seksjonsomsluttningen, framfor rett på
       document: i temaeditoren byttes bare den ene seksjonen ut ved
       endring, og da skal vi binde opp den NYE skuffen, ikke en gammel som
       ennå ligger i DOM-en. Faller omsluttningen bort, er document en
       trygg reserve – #NavDrawer finnes bare én gang. */
    var skuffRot = (seksjon && seksjon.closest('.shopify-section')) || document;

    aapentPunkt = null;
    avbrytTimere();
    Header.init();
    initDesktop(rot);
    initMobil(skuffRot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor bygger headeren på nytt ved hver innstillingsendring.
     Uten dette mister menyen all oppførsel i det øyeblikket Henrik endrer
     noe – og han ville trodd at menyen var ødelagt. */
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector('[data-section-type="header"]')) {
      init();
    }
  });
})();
